// Proportional ("cqi-equivalent") sizing with a shared readability floor.
// Web and native share the exact same math — at the same `tileSize` they
// render identically — which is the load-bearing invariant for this
// component. The floors kick in only on thumbnail-sized cards (the default
// 88px phone tile), keeping the gloss readable; on larger
// cards (wider viewports, iPads, web at any size > thumbnail) the floors
// are inert and the text scales like a CSS `transform: scale` of the
// thumbnail.
//
// Ratios are fractions of the card's pixel width — the equivalent of `cqi`
// for React Native, which doesn't honor CSS container queries on iOS/Android.
export const GLOSS_FONT_RATIO = 0.085;
export const GLOSS_LINE_HEIGHT_RATIO = 1.2;

// Readability floors, applied identically on every platform. Chosen to match
// the original iOS phone-thumbnail render (12px gloss / 16px gloss line-height)
// so a 390px iOS phone keeps its long-standing look. At the 88px phone tile
// the 16px line-height floor exceeds the proportional 14.4px height.
// card-details-tile-ui.tsx reserves two actual line heights plus the due
// line and spacing before allocating the remaining height to the front of
// the tile.
const GLOSS_FONT_MIN_PX = 12;
const GLOSS_LINE_HEIGHT_MIN_PX = 16;

export function getGlossSizing(tileSize: number): { fontSize: number; lineHeight: number } {
  const fontSize = Math.max(GLOSS_FONT_MIN_PX, tileSize * GLOSS_FONT_RATIO);
  const lineHeight = Math.max(GLOSS_LINE_HEIGHT_MIN_PX, fontSize * GLOSS_LINE_HEIGHT_RATIO);
  return { fontSize, lineHeight };
}
